import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/headerOrfooter/1GitHub.svg'
import _imports_1 from '../assets/img/headerOrfooter/2.svg'
import _imports_2 from '../assets/img/headerOrfooter/3WeChat.svg'
import _imports_3 from '../assets/img/introduce/IDP小助手.png'
import _imports_4 from '../assets/img/headerOrfooter/4B站.svg'
import _imports_5 from '../assets/img/headerOrfooter/知乎.svg'
import _imports_6 from '../assets/img/headerOrfooter/download.png'


const _withScopeId = n => (_pushScopeId("data-v-b0f8a5e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "panel-footer",
  style: {"width":"100%","overflow":"hidden"}
}
const _hoisted_2 = { class: "container row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left col-xxl-5 col-xl-5 col-lg-4 col-md-12 col-sm-12 col-xs-12" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "wow bounceIn",
    "data-wow-duration": "1s",
    "data-wow-delay": ".5s"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "wow bounceInLeft" }, " 白海科技是领先的云原生AI基础软件服务商，致力于帮助AI开发者和企业解决AI落地过程中的效率、性能、成本等问题。白海科技提供模块化架构的新一代云原生AI平台IDP，便捷轻量地满足AI开发生产全流程需求，并极大提升AI计算性能和资源利用率。基于IDP基础平台构建IDP LM – 一站式专属大模型构建与应用加速平台，帮助企业快速构建自有可控大模型。白海科技坚持自主创新，在核心领域已积累丰富专利、软件著作权、全球顶会论文等。 ")
], -1))
const _hoisted_4 = { class: "right col-xxl-7 col-xl-7 col-lg-8 col-md-12 col-sm-12 col-xs-12" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right-item col-xxl-1 col-xl-1 col-lg-0 col-md-0 col-sm-0 col-xs-0" }, null, -1))
const _hoisted_7 = { class: "right-item col-xxl-1-5 col-xl-1-5 col-lg-1-5 col-md-3 col-sm-3 col-xs-3 col-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "wow bounce",
  "data-wow-delay": ".1s"
}, "产品", -1))
const _hoisted_9 = { class: "right-item col-xxl-1-5 col-xl-1-5 col-lg-1-5 col-md-3 col-sm-3 col-xs-3 col-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "wow bounce",
  "data-wow-delay": ".2s",
  style: {"margin-bottom":"24px"}
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  onClick: "{openurl}",
  target: "_blank",
  class: "nav-link wow bounceInLeft",
  href: "http://imcgpt.baihai.co:9997/information"
}, "IMC GPT", -1))
const _hoisted_12 = { class: "right-item col-xxl-1-5 col-xl-1-5 col-lg-1-5 col-md-3 col-sm-3 col-xs-3 col-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "wow bounce",
  "data-wow-delay": ".2s"
}, "公司", -1))
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"right-item col-xxl-1-5 col-xl-1-5 col-lg-1-5 col-md-3 col-sm-3 col-xs-3 col-3\" data-v-b0f8a5e6><p class=\"wow bounce\" data-wow-delay=\".3s\" data-v-b0f8a5e6>资源</p><a class=\"nav-link wow bounceInRight\" data-wow-delay=\".7s\" target=\"_blank\" href=\"https://github.com/BaihaiAI/IDP\" data-v-b0f8a5e6>Github</a><a class=\"nav-link wow bounceInRight\" data-wow-delay=\".7s\" href=\"https://gitee.com/baihai-idp/IDP\" data-v-b0f8a5e6>Gitee</a><a class=\"nav-link wow bounceInRight\" data-wow-delay=\".7s\" href=\"https://www.zhihu.com/column/c_1465275278654500864\" data-v-b0f8a5e6>博客</a><a class=\"nav-link wow bounceInRight\" data-wow-delay=\".7s\" href=\"https://www.yuque.com/baihai_idp/kencft?#\" data-v-b0f8a5e6>文档</a></div><div class=\"right-item col-xxl-5 col-xl-5 col-lg-6 col-md-12 col-sm-12 col-xs-12 col-12\" data-v-b0f8a5e6><p class=\"wow bounce\" data-wow-delay=\".4s\" data-v-b0f8a5e6>联系我们</p><div class=\"icons\" data-v-b0f8a5e6><a class=\"wow animate__rubberBand\" target=\"_blank\" data-wow-delay=\"1.3s\" href=\"https://github.com/BaihaiAI/IDP\" data-v-b0f8a5e6><img src=\"" + _imports_0 + "\" alt=\"\" data-v-b0f8a5e6></a><a class=\"wow animate__rubberBand\" target=\"_blank\" data-wow-delay=\"1.2s\" href=\"https://join.slack.com/t/idp-tjo1834/shared_invite/zt-1kee8cd8x-iNZ0rvwClRfx7sLgmmKKyg\" data-v-b0f8a5e6><img src=\"" + _imports_1 + "\" alt=\"\" data-v-b0f8a5e6></a><span class=\"weixin wow animate__rubberBand\" data-wow-delay=\"1.1s\" data-v-b0f8a5e6><img src=\"" + _imports_2 + "\" alt=\"\" data-v-b0f8a5e6><div class=\"img\" data-v-b0f8a5e6><img src=\"" + _imports_3 + "\" alt=\"\" data-v-b0f8a5e6></div><div class=\"triangle\" data-v-b0f8a5e6></div><div class=\"tool\" data-v-b0f8a5e6></div></span><a class=\"wow animate__rubberBand\" data-wow-delay=\"1s\" href=\"https://space.bilibili.com/1227589642\" data-v-b0f8a5e6><img src=\"" + _imports_4 + "\" alt=\"\" data-v-b0f8a5e6></a><a class=\"wow animate__rubberBand\" data-wow-delay=\".9s\" href=\"https://www.zhihu.com/column/c_1465275278654500864\" data-v-b0f8a5e6><img src=\"" + _imports_5 + "\" alt=\"\" data-v-b0f8a5e6></a></div><div class=\"consulting wow animate__wobble\" data-wow-delay=\".4s\" data-v-b0f8a5e6>商务咨询</div><span class=\"email wow animate__wobble\" data-wow-delay=\".2s\" data-v-b0f8a5e6>contact@baihai.ai</span></div>", 2)
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"put-on-records\" data-v-b0f8a5e6><div class=\"txt\" data-v-b0f8a5e6> © 2024 北京白海科技有限公司    <a href=\"https://beian.miit.gov.cn/#/Integrated/recordQuery\" target=\"_blank\" data-v-b0f8a5e6>京 ICP备 2021026700号-1</a>    <a href=\"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011402013625\" target=\"_blank\" data-v-b0f8a5e6><img src=\"" + _imports_6 + "\" alt=\"\" data-v-b0f8a5e6>京公网安备 11011402013625号</a></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_router_link, {
              to: "/studio",
              class: "nav-link wow bounceInLeft",
              href: "#"
            }, {
              default: _withCtx(() => [
                _createTextVNode("AI平台")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/studio",
              class: "nav-link nav-link-with-line wow bounceInLeft",
              href: "#",
              style: {"font-size":"9.8px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("IDP Studio")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/engine",
              class: "nav-link nav-link-with-line wow bounceInLeft",
              href: "#",
              style: {"font-size":"9.8px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("IDP Engine")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/aigc",
              class: "nav-link nav-link-with-line wow bounceInLeft",
              href: "#",
              style: {"font-size":"9.8px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("IDP LM")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_router_link, {
              to: "/gpucalc",
              class: "nav-link wow bounceInDown",
              "data-wow-delay": ".5s",
              href: "#"
            }, {
              default: _withCtx(() => [
                _createTextVNode("GPU 计算")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/gpucalc",
              class: "nav-link wow bounceInDown",
              "data-wow-delay": ".5s",
              href: "#"
            }, {
              default: _withCtx(() => [
                _createTextVNode("AI 市场")
              ]),
              _: 1
            }),
            _hoisted_11
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_router_link, {
              to: "/introduce",
              class: "nav-link wow bounceInDown",
              "data-wow-delay": ".5s",
              href: "#"
            }, {
              default: _withCtx(() => [
                _createTextVNode("公司简介")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/introduce",
              class: "nav-link wow bounceInDown",
              "data-wow-delay": ".5s",
              href: "#"
            }, {
              default: _withCtx(() => [
                _createTextVNode("联系我们")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/recruit",
              class: "nav-link wow bounceInDown",
              "data-wow-delay": ".5s",
              href: "#"
            }, {
              default: _withCtx(() => [
                _createTextVNode("加入我们")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "unite",
              class: "nav-link wow bounceInDown",
              "data-wow-delay": ".5s",
              href: "#"
            }, {
              default: _withCtx(() => [
                _createTextVNode("合作伙伴")
              ]),
              _: 1
            })
          ]),
          _hoisted_14
        ])
      ])
    ]),
    _hoisted_16
  ]))
}